export const getFirstAvailableTimeSlot = ({ firstAvailableTimeSlot }) =>
  firstAvailableTimeSlot.time;
export const getFirstAvailableTimeSlotTeamsId = ({ firstAvailableTimeSlot }) =>
  firstAvailableTimeSlot.teamsId;



// WEBPACK FOOTER //
// ./src/store/reducers/firstAvailableTimeSlot/selectors.js